import React from 'react';

// Use React.memo to optimize component performance
const SegmentTable = React.memo(function SegmentTable({ segments, totalDistance, title, className }) {
  // Move all useMemo calls before conditional checks
  // Use useMemo to cache computed results and avoid repetitive calculations
  const segmentRows = React.useMemo(() => {
    if (!segments || segments.length === 0) return [];
    
    return segments.map((segment, index) => {
      // Calculate the percentage of this segment in total distance
      const percentage = (segment.distance / totalDistance) * 100;
      // Determine if this is a long segment (over 150% of average)
      const isLongSegment = percentage > (100 / segments.length) * 1.5;
      
      return (
        <tr key={index} className={isLongSegment ? 'long-segment' : ''}>
          <td>{segment.from.name} → {segment.to.name}</td>
          <td>{segment.distance.toFixed(2)} km</td>
          <td className={isLongSegment ? 'high-percentage' : ''}>
            {percentage.toFixed(2)}%
          </td>
        </tr>
      );
    });
  }, [segments, totalDistance]);
  
  // Format total distance
  const formattedDistance = React.useMemo(() => {
    return totalDistance ? totalDistance.toFixed(2) : "0.00";
  }, [totalDistance]);
  
  // Check for no data after all Hooks
  if (!segments || segments.length === 0) {
    return (
      <div className={`segment-table ${className}`}>
        <h6>{title}</h6>
        <p>No segment data available</p>
      </div>
    );
  }
  
  return (
    <div className={`segment-table ${className}`}>
      <h6>{title}</h6>
      <table>
        <thead>
          <tr>
            <th>Segment</th>
            <th>Distance</th>
            <th>Percentage</th>
          </tr>
        </thead>
        <tbody>
          {segmentRows}
        </tbody>
        <tfoot>
          <tr>
            <td><strong>Total</strong></td>
            <td colSpan="2"><strong>{formattedDistance} km</strong></td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
});

export default SegmentTable; 